<template>
  <div :class="['message-box',showType === 'center' ? 'opacity-mask':'']" v-show="isShowMessageBox">
    <div v-if="showType === 'center'" class="message-content-center">
      <div class="message-content-center-header">
        <img :src="iconUrl" alt=""/>
        <div class="message-content-center-header-font">{{ message }}</div>
      </div>
      <div class="message-content-center-content">{{ contentMessage }}</div>
    </div>
    <div v-else class="message-content-top">
      <img :src="iconUrl" alt=""/>
      <div>{{ message }}</div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    message: {
      type: String,
      default: () => {
        return "";
      },
    },
    iconUrl: {
      type: Object,
      default: () => {
        return null;
      },
    },
    duration: {
      type: Number,
      default: () => {
        return 2000;
      },
    },
    showType: { //默认顶部展示，可传center，居中展示
      type: String,
      default: "top",
    },
    contentMessage:{
      type: String,
      default: () => {
        return "";
      },
    }
  },
  data() {
    return {
      isShowMessageBox: false,
      resolve: "",
      reject: "",
      promise: "", // 保存promise对象
    };
  },
  methods: {
    // 弹出messageBox,并创建promise对象
    showMsgBox: function () {
      let that = this;
      that.pFontState = that.tips && (that.tips === "success" || this.tips === "error");
      that.isShowMessageBox = true;
      that.promise = new Promise((resolve, reject) => {
        that.resolve = resolve;
        that.reject = reject;
      });
      setTimeout(() => {//展示传来的时间，默认2s
        that.closeBox()
      }, that.duration);
      // 返回promise对象
      return that.promise;
    },
    closeBox: function () {
      this.isShowMessageBox = false;
    },

  },
};
</script>

<style lang="scss" scoped>
.message-box {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  z-index: 10000;
  user-select: none;

  .message-content-top {
    position: absolute;
    top: var(--margin-y-24);
    left: 50%;
    min-height: var(--height-56);
    transform: translateX(-50%); /* 50%为自身尺寸的一半 */
    padding: var(--padding-x-16);
    border-radius: var(--border-radius-6);
    background: var(--color-white-base);
    box-shadow: 0 var(--margin-x-12) var(--margin-y-40) 0 rgba(0, 0, 0, 0.1);
    border: var(--width-1) solid var(--color-gray-line-light);
    display: flex;
    align-content: center;
    align-items: center;
    z-index: 50001;
    animation: post-list-row .3s;
    -webkit-animation: post-list-row .3s;

    img {
      width: var(--width-20);
      height: var(--height-20);
    }

    div {
      font-size: var(--font-size-m);
      color: #1D2129;
      margin-left: var(--margin-x-8);
      line-height: var(--font-line-height-m);
      cursor: pointer;
    }
  }

  /*自定义动画*/
  @keyframes post-list-row {
    0% {
      opacity: 0;
      -webkit-transform: translateY(40px);
      transform: translateY(40px) translateX(-50%);
    }
    100% {
      opacity: 1;
      -webkit-transform: translateY(0);
      transform: translateY(0) translateX(-50%);
    }
  }
  @-webkit-keyframes post-list-row {
    0% {
      opacity: 0;
      -webkit-transform: translateY(40px) translateX(-50%);
      transform: translateY(40px) translateX(-50%);
    }
    100% {
      opacity: 1;
      -webkit-transform: translateY(0) translateX(-50%);
      transform: translateY(0) translateX(-50%);
    }
  }

  .message-content-center {
    width: var(--width-489);
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    padding: var(--padding-x-24);
    border-radius: var(--border-radius-6);
    background: var(--color-white-base);
    box-shadow: 0 var(--margin-x-12) var(--margin-y-40) 0 rgba(0, 0, 0, 0.1);
    z-index: 50001;
    img {
      width: var(--width-24);
      height: var(--height-24);
    }
    &-header-font {
      font-size: var(--font-size-h6);
      color: #1D2129;
      margin-left: var(--margin-x-8);
      line-height: var(--font-line-height-m);
      font-weight: var(--font-weight-l);
    }
    &-header {
      display: flex;
      align-content: center;
      align-items: center;
    }
    &-content {
      font-size: var(--font-size-m);
      color: #1D2129;
      margin-top: var(--margin-y-16);
      line-height: var(--font-line-height-s);
    }
  }
}

.opacity-mask {
  background-color: rgba(0,0,0,0.6);
}

</style>



// WEBPACK FOOTER //
// src/components/messageBoxTip/index.vue